
<template>
  <div>
    <vs-sidebar click-not-close parent="#pekerjaan-app" :hidden-background="true" class="full-vs-sidebar pekerjaan-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
      <div class="pekerjaan-sidebar-content px-0 sm:pb-6 h-full">
          <div class="flex flex-wrap items-center pekerjaan-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
              <div class="flex mb-4">
                  <div class="flex items-center">
                      <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
                      <h4>{{ Object.entries(this.data).length === 0 ? "Add New" : "Update" }} Pekerjaan</h4>
                  </div>
              </div>

              <div class="ml-10 mb-4 mt-1">
                <template v-if="Taxonomy != 'trash'">
                  <div class="pekerjaan__actions--single flex items-baseline">

                    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                      <feather-icon icon="TagIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4"></feather-icon>
                      <vs-dropdown-menu style="z-index: 40001">
                        <vs-dropdown-item v-for="(label, index) in pekerjaanTags" :key="index" @click.stop>
                          <vs-checkbox :vs-value="label.name" v-model="currentPekerjaanLabels">{{ label.name }}</vs-checkbox>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                    
                    <feather-icon icon="TrashIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="$emit('removePekerjaan')"></feather-icon>
                    <!--
                    <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousPekerjaan')" />
                    <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('nextPekerjaan')" />
                    -->
                  </div>
                </template>
                <template v-else>
                  <div class="pekerjaan__actions--single flex items-baseline">

                      <feather-icon icon="RepeatIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="$emit('putbackPekerjaan')"></feather-icon>
                  </div>
                </template>
              </div>
          </div>

          <component :is="scrollbarTag" class="scroll-area-pekerjaan-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">

            <vx-card class="px-2">
              <div class="pekerjaan__content break-words mt-4 mb-4">
              
                <vs-row class="mt-4">
                  <vs-col vs-align="center" class="" vs-w="12">
                    <vs-input label="Nama Pekerjaan" v-model="dataPekerjaan" class="w-full" v-dis="'E'"/>
                  </vs-col>
                </vs-row>

                <vs-row class="mt-4">
                  <vs-col vs-align="center" class="pr-2" vs-w="6">
                    <vs-select
                      class="w-full"
                      label="Bidang"
                      v-model="dataBidang"
                      @change="pilihDivisi"
                      @click.prevent="changeClickDivisi"
                      v-dis="'E'"
                      >
                        <vs-select-item value="pilih" text="Pilih"/>
                        <vs-select-item :key="itemx.id" :value="itemx.id" :text="itemx.name" v-for="itemx in listBidang"/>
                    </vs-select>
                  </vs-col>
                  <vs-col vs-align="center" class="" vs-w="6">
                    <vs-select
                      class="w-full"
                      label="Divisi"
                      v-model="dataDivisi"
                      @change="pilihKelompok"
                      @click.prevent="changeClickKelompok"
                      v-dis="'E'"
                      >
                        <vs-select-item value="pilih" text="Pilih"/>
                        <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in listDivisi"/>
                    </vs-select>
                  </vs-col>
                </vs-row>

                <vs-row class="mt-4">
                  <vs-col vs-align="center" class="pr-2" vs-w="6">
                    <vs-select
                      class="w-full"
                      label="Kelompok"
                      v-model="dataKelompok"
                      @change="pilihSub"
                      @click.prevent="changeClickSub"
                      v-dis="'E'"
                      >
                        <vs-select-item value="pilih" text="Pilih"/>
                        <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in listKelompok"/>
                    </vs-select>
                  </vs-col>
                  <vs-col vs-align="center" class="" vs-w="6">
                    <vs-select
                      class="w-full"
                      label="Sub"
                      v-model="dataSub"
                      @change="pilihAnalisa"
                      @click.prevent="changeClickAnalisa"
                      v-dis="'E'"
                      >
                        <vs-select-item value="pilih" text="Pilih"/>
                        <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.name}`" v-for="itemx in listSub"/>
                    </vs-select>
                  </vs-col>
                </vs-row>
              
                <vs-row class="mt-4">
                  <vs-col vs-align="center" class="" vs-w="12">
                    <vs-select
                      class="w-full"
                      label="Analisa Satuan"
                      v-model="dataAnalisa"
                      @change="pilihSatuan"
                      v-dis="'E'"
                      >
                        <vs-select-item value="pilih" text="Pilih"/>
                        <vs-select-item :key="itemx.id" :value="itemx.id" :text="`${itemx.kode} ${itemx.task_title}`" v-for="itemx in listAnalisa"/>
                    </vs-select>
                  </vs-col>
                </vs-row>
              
                <vs-row class="mt-4">
                  <vs-col vs-align="left" class="px-2" vs-w="4">
                    <vs-input-number label="Mulai Hari:" v-model="dataMulai" class=""/>
                  </vs-col>
                  <vs-col vs-align="left" class="px-2" vs-w="4">
                    <vs-input-number label="volume:" v-model="dataQuantity" @input="updateTotal"/>
                  </vs-col>
                  <vs-col vs-align="left" class="px-2" vs-w="4">
                    <vs-input-number label="tenaga:" v-model="dataTenaga" @input="updateTotalHari"/>
                  </vs-col>
                </vs-row>
              
                <vs-row class="mt-4">
                  <vs-col vs-align="left" class="px-2" vs-w="4">
                    <vs-select
                      class=""
                      label="Urutan"
                      v-model="dataUrutan"
                      >
                        <vs-select-item value="pilih" text="Pilih"/>
                        <vs-select-item :key="key" :value="urutan" :text="urutan" v-for="(urutan, key) in totalPekerjaan"/>
                    </vs-select>
                  </vs-col>
                  <vs-col vs-align="left" class="px-2" vs-w="4">
                    <vs-row>
                      <vs-col vs-align="center" vs-w="6">
                        <vs-select
                          class="w-full"
                          label="Penanganan"
                          v-model="dataPenanganan"
                          @change="pilihPenanganan"
                          @click.prevent="changePilihPenanganan"
                          >
                            <vs-select-item value="pilih" text="Pilih"/>
                            <vs-select-item :key="key" :value="penanganan.value" :text="penanganan.text" v-for="(penanganan, key) in listPenanganan"/>
                        </vs-select>
                      </vs-col>
                      <vs-col vs-align="center" vs-w="6" v-if="subshow">
                        <vs-select
                          class="w-full"
                          label="Kontak"
                          v-model="dataSubkontraktor"
                          >
                            <vs-select-item value="0" text="Pilih"/>
                            <vs-select-item :key="key" :value="subkontraktor.id" :text="subkontraktor.name" v-for="(subkontraktor, key) in listSubkontraktor"/>
                        </vs-select>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                  <vs-col vs-align="left" class="px-2" vs-w="4">
                    <p class="font-bold" v-if="dataGroup != 'sni'">Lama Pengerjaan {{ dataHari }} Hari</p>
                    <vs-input label="Lama Pengerjaan / Hari" v-model="dataHari" class="" v-dis="'E'"/>
                  </vs-col>
                </vs-row>
              
                <vs-row class="mt-4" v-if="dataGroup === 'sni'">
                  <vs-col vs-align="left" class="px-2" vs-w="4">
                    <p class="w-full">Harga Satuan : {{dataHarga | currency}}</p>
                  </vs-col>
                  <vs-col vs-align="left" class="px-2" vs-w="4">
                    <p class="font-bold">Total {{dataTotal | currency}} / {{dataSatuan}}</p>
                  </vs-col>
                  <vs-col vs-align="left" class="px-2" vs-w="4">
                    <p class="font-bold">Produktivitas : {{ dataProduktivitas }} {{dataSatuan}}/hari</p>
                  </vs-col>
                </vs-row>
                
                <!--
                <vs-row class="flex flex-wrap justify-between">
                  <vs-col vs-align="center" class="pr-2 pt-6" vs-w="4">
                    <span class="">Tenaga Kerja : {{ dataKoefisienTenaga }} org/hari</span>
                  </vs-col>
                  <vs-col vs-align="right" class="pt-6 text-right" vs-w="4">
                    <span class="font-bold">Lama Pengerjaan {{ dataHari }} Hari</span>
                  </vs-col>
                </vs-row>
                -->

                <vs-row class="mt-4">
                  <vs-col vs-align="center" class="" vs-w="12">
                    <template v-if="Thumbnail" class="mt-5">
                      
                      <div class="img-container w-full" v-if="upImg">
                        <img :src="getImage('/perencanaan/'+Thumbnail)" alt="" class="responsive" v-if="upImg">
                      </div>

                      <div class="img-container w-full">
                        <img :src="Thumbnail" alt="" class="responsive">
                      </div>

                      <!-- Image upload Buttons -->
                      <div class="modify-img flex justify-between mt-5 mb-5">
                        <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                        <vs-button class="mr-4" @click="$refs.updateImgInput.click();upImg = false">Update Image</vs-button>
                        <!--<vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>-->
                      </div>
                    </template>

                    <div class="upload-img mt-5" v-if="!Thumbnail">
                      <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
                      <vs-button @click="$refs.uploadImgInput.click();upImg = false">Upload Image</vs-button>
                    </div>
                  </vs-col>
                </vs-row>

                <vs-divider></vs-divider>

                <div class="flex flex-wrap items-center justify-between py-4" slot="footer">
                  <vs-button type="border" color="danger" @click="cancelForm">Cancel</vs-button>
                  <vs-button @click="submitData" :disabled="!isFormValid">Submit</vs-button>
                </div>

              </div>
            </vx-card>
          </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import PekerjaanCard from './PekerjaanCard.vue'
import { mapGetters } from 'vuex'

export default {
  props: {
    pekerjaanTags: {
      type: Array,
      required: true
    },
    listBidang: {
      type: Array,
      required: true
    },
    openPekerjaanId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    data: {
      type: Object,
      default () { return { };}
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    pekerjaanFilter: {
      type: String
    },
    Taxonomy: {
      type: String
    },
    RABs: {
      required: true
    },
    totalPekerjaan: {
      required: true
    },
  },
  data () {
    return {
      dataAnalisa: 'pilih',
      changeAnalisa: false,
      listAnalisa : [],

      dataBidang: 'pilih',
      changeBidang: false,
      dataDivisi: 'pilih',
      changeDivisi: false,
      dataKelompok: 'pilih',
      changeKelompok: false,
      dataSub: 'pilih',
      changeSub: false,
      listSub: [],
      listDivisi: [],
      listKelompok: [],

      dataPenanganan: 'pilih',
      listPenanganan: [
        {value: 'utama', text: "Kontraktor Utama"},
        {value: 'sub', text: "Subkontraktor"},
      ],
      subshow : false,
      changePenanganan: false,
      dataSubkontraktor: 0,

      Thumbnail : null,
      upImg: true,

      dataId: null,
      dataPekerjaan: null,
      dataHarga: 0,
      dataKoefisienTenaga: 0,
      dataSatuan: null,
      dataMulai: 0,
      dataQuantity: 0,
      dataTenaga: 1,
      dataProduktivitas: 0,
      dataTotal: 0,
      dataHari: 0,
      dataHariSementara: 0,
      dataKode: null,
      dataParent: null,
      dataUrutan: 'pilih',
      dataGroup: null,

      showThread: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50
      }
    }
  },
  watch: {
    isSidebarActive (value) {
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }

      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {

        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: '.pekerjaan__content',
          scale: 0.80
        })

        const { id, task_title, task_unit, task_quantity, ahsp, hari, mulai, urutan, thumbnail, tenaga, produktivitas, kode, task_group, penanganan, subkontraktor } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataPekerjaan = task_title
        this.dataAnalisa = task_unit
        this.dataQuantity = task_quantity
        this.dataSatuan = ahsp.nama_satuan
        this.dataBidang = ahsp.pekerjaan_bidang
        this.dataDivisi = ahsp.pekerjaan_divisi
        this.dataKelompok = ahsp.pekerjaan_kelompok
        this.dataSub = ahsp.pekerjaan_sub
        this.dataHarga = ahsp.task_total
        this.dataKoefisienTenaga = ahsp.koefisien_tenaga
        this.dataTotal = ahsp.task_total * task_quantity
        //const B = ahsp.koefisien_tenaga * task_quantity
        this.dataGroup = task_group
        this.dataHari = hari
        if (!mulai) {
          this.dataMulai = 0
        } else {
          this.dataMulai = mulai
        }
        this.dataUrutan = urutan
        this.Thumbnail = thumbnail
        if (!tenaga) {
          this.dataTenaga = 1
        } else {
          this.dataTenaga = tenaga
        }
        if (!produktivitas) {
          this.dataProduktivitas = 0
        } else {
          this.dataProduktivitas = produktivitas
        }

        if (this.dataGroup != 'sni') {
          this.dataHariSementara = ahsp.hari
        } 

        if (!penanganan) {
          this.dataPenanganan = 'utama'
        } else {
          this.dataPenanganan = penanganan
          this.subshow = true
          if (subkontraktor) {
            this.dataSubkontraktor = subkontraktor
          } else {
            this.dataSubkontraktor = 0
          }
        }

        this.dataKode = kode
        
        

        setTimeout(() => {
          this.$vs.loading.close('.pekerjaan__content > .con-vs-loading')
        }, 1000)

        //this.initValues()
      }
    }
  },
  computed: {
    isFormValid () {
      let subs = true
      if (this.dataPenanganan === 'sub' && this.dataSubkontraktor == 0) {
        subs = false
      }
      return !this.errors.any() && this.dataPekerjaan && this.dataHarga != 0 && this.dataSatuan && this.dataAnalisa != 'pilih' && this.dataUrutan != 'pilih' && this.dataPenanganan != 'pilih' && this.dataQuantity != 0 && this.dataTenaga != 0 && this.dataMulai != 0 && this.dataTotal != 0 && this.dataHari != 0 && subs
    },
    listSubkontraktor () {
      return this.$store.state.subkontraktor.kontaks
    },
    currentPekerjaan () {
      return this.$store.getters['pekerjaan/getPekerjaan'](this.openPekerjaanId)
    },
    labelColor () {
      return (label) => {
        const tags = this.$store.state.pekerjaan.pekerjaanTags
        return tags.find((tag) => {
          return tag.name === label
        }).color
      }
    },
    currentPekerjaanLabels: {
      get () {
        return this.data.labels
      },
      set (value) {
        if (Array.isArray(value)) {
          const payload = { id: this.openPekerjaanId, labels: value }
          this.$store.dispatch('pekerjaan/setLabels', payload)
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    })
  },
  methods: {
    submitData () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '.pekerjaan__content',
        scale: 0.45
      })
      
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {

            let formData = new FormData()
            formData.set('task_title', this.dataPekerjaan)
            formData.set('task_total', this.dataTotal)
            formData.set('task_unit', this.dataAnalisa)
            formData.set('task_price', this.dataHarga)
            formData.set('task_quantity', this.dataQuantity)
            formData.set('task_parent', this.dataId)
            formData.set('task_type', 'anggaran')
            formData.set('task_sub_type', 'pekerjaan')
            formData.set('task_status', 'inherit')
            formData.set('task_group', this.dataGroup)
            formData.set('comment_status', 'null')
            formData.set('task_password','null')
            
            if (this.Thumbnail != null && this.upImg != true) {
              formData.append('thumbnail', this.Thumbnail)
            } else {
              formData.set('thumbnail', 'empty')
            }

            let meta = {
              hari : this.dataHari,
              mulai : this.dataMulai,
              urutan : this.dataUrutan,
              tenaga : this.dataTenaga,
              produktivitas : this.dataProduktivitas,
              satuan: this.dataSatuan,
              kode: this.dataKode,
              penanganan: this.dataPenanganan,
              subkontraktor: this.dataSubkontraktor
            }
            formData.set('meta', JSON.stringify(meta))
            this.$store.dispatch('pekerjaan/updatePekerjaan', formData)
            .then((response) => {
              this.upImg = true
              this.$vs.loading.close('.pekerjaan__content > .con-vs-loading')
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
              this.initValues()
              this.$emit('closeSidebar')
            })
            .catch(error => {
              this.$vs.loading.close('.pekerjaan__content > .con-vs-loading')
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          } else {
            let formData = new FormData()
            formData.set('id', this.dataId)
            formData.set('task_title', this.dataPekerjaan)
            formData.set('task_total', this.dataTotal)
            formData.set('task_unit', this.dataAnalisa)
            formData.set('task_price', this.dataHarga)
            formData.set('task_quantity', this.dataQuantity)
            formData.set('task_parent', this.RABs.id)
            formData.set('task_type', 'anggaran')
            formData.set('task_sub_type', 'pekerjaan')
            formData.set('task_status', 'publish')
            formData.set('task_group', this.dataGroup)
            formData.set('comment_status', 'null')
            formData.set('task_password','null')
            
            if (this.Thumbnail != null && this.upImg != true) {
              formData.append('thumbnail', this.Thumbnail)
            } else {
              formData.set('thumbnail', 'empty')
            }

            let meta = {
              hari : this.dataHari,
              mulai : this.dataMulai,
              urutan : this.dataUrutan,
              tenaga : this.dataTenaga,
              produktivitas : this.dataProduktivitas,
              satuan: this.dataSatuan,
              kode: this.dataKode,
              penanganan: this.dataPenanganan,
              subkontraktor: this.dataSubkontraktor
            }
            formData.set('meta', JSON.stringify(meta))
            //formData.set('total', this.totalPekerjaan+1)
            const total = this.totalPekerjaan+1

            this.$store.dispatch('pekerjaan/addPekerjaan', formData, total)
            .then((response) => {
              this.upImg = true
              this.$vs.loading.close('.pekerjaan__content > .con-vs-loading')
              this.$vs.notify({
                title: 'Berhasil',
                color  : 'success',
                text  : response.message,
              })
              this.initValues()
              this.$emit('closeSidebar')
            })
            .catch(error => {
              this.$vs.loading.close('.pekerjaan__content > .con-vs-loading')
              let {data} = error.response
              this.$vs.notify({
                title: 'Error',
                text: data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            })
          }
        }
      })
    },
    changePilihPenanganan () {
      this.changePenanganan = true
    },
    pilihPenanganan () {
      if (this.dataPenanganan === 'sub') {
        this.subshow = true
      } else {
        this.subshow = false
      }
    },
    toggleIsStarred () {
      const payload = { pekerjaanId: this.openPekerjaanId, value: !this.currentPekerjaan.isStarred }
      this.$store.dispatch('pekerjaan/toggleIsPekerjaanStarred', payload)
    },
    moveTo (to) {
      this.$emit('closeSidebar')
      this.$emit('moveTo', to)
    },
    changeClickDivisi () {
      this.changeDivisi = true
    },
    pilihDivisi () {
      this.listDivisi = []
      this.listKelompok = []
      this.listSub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataBidang != 'pilih') {
        this.axios.get('/term-parent/'+this.dataBidang, configs).then((response) => {
          let {data} = response.data
          this.listDivisi = data
        })
      }
      if (this.changeDivisi === true) {
        this.dataDivisi = 'pilih'
        this.dataKelompok = 'pilih'
        this.dataSub = 'pilih'
      }
    },
    changeClickKelompok () {
      this.changeKelompok = true
    },
    pilihKelompok () {
      this.listKelompok = []
      this.listSub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataDivisi != 'pilih') {
        //this.dataKelompok = 'pilih'
        this.axios.get('/term-parent/'+this.dataDivisi, configs).then((response) => {
          let {data} = response.data
          this.listKelompok = data
        })
      }
      if (this.changeKelompok === true) {
        this.dataKelompok = 'pilih'
        this.dataSub = 'pilih'
      }
    },
    changeClickSub () {
      this.changeSub = true
    },
    pilihSub () {
      this.list_sub = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataKelompok != 'pilih') {
        this.axios.get('/term-parent/'+this.dataKelompok, configs).then((response) => {
          let {data} = response.data
          this.listSub = data
        })
      }
      if (this.changeSub === true) {
        this.dataSub = 'pilih'
      }
    },
    pilihAnalisa () {
      this.listAnalisa = []
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      if (this.dataSub != 'pilih') {
        this.axios.get('/task-list-analisa-sub/'+this.dataSub, configs).then((response) => {
          let {data} = response.data
          this.listAnalisa = data
        })
      }
      if (this.changeAnalisa === true) {
        this.dataAnalisa = 'pilih'
      }
    },
    changeClickAnalisa () {
      this.changeAnalisa = true
    },
    pilihSatuan () {
      if (this.changeAnalisa === true) {
        this.dataHarga = 0
        this.dataSatuan = null
        this.dataUnit = null
        const ItemIndex = this.listAnalisa.find((pekerjaan) => pekerjaan.id === this.dataAnalisa)
        this.dataHarga = ItemIndex.task_total
        this.dataKoefisienTenaga = ItemIndex.koefisien_tenaga
        this.dataSatuan = ItemIndex.nama_satuan
        this.dataUnit = ItemIndex.id
        this.dataKode = ItemIndex.kode
        if (this.dataPekerjaan === null) {
          this.dataPekerjaan = ItemIndex.task_title+' - '+this.RABs.task_title
        }
        this.dataGroup = ItemIndex.task_group
        if (this.dataGroup != 'sni') {
          this.dataHariSementara = ItemIndex.hari
        } 
      }
    },
    updateTotal () {
      this.dataTotal = parseFloat(this.dataHarga) * parseFloat(this.dataQuantity)
      if (this.dataGroup === 'sni') {
        let G = parseFloat(this.dataQuantity) / ( parseFloat(this.dataKoefisienTenaga) * this.dataTenaga )
        this.dataHari = G.toFixed(0)
        let H = this.dataKoefisienTenaga * this.dataTenaga
        this.dataProduktivitas = H.toFixed(2)
      } else {
        let G = this.dataHariSementara * this.dataQuantity
        this.dataHari = G.toFixed(0)
      }
    },
    updateTotalHari () {
      //let G = parseFloat(this.dataQuantity) * parseFloat(this.dataKoefisienTenaga) / this.dataTenaga
      let G = parseFloat(this.dataQuantity) / ( parseFloat(this.dataKoefisienTenaga) * this.dataTenaga )
      this.dataHari = G.toFixed(0)
      //let H = this.dataHari * this.dataTenaga / parseFloat(this.dataQuantity)
      let H = this.dataKoefisienTenaga * this.dataTenaga
      this.dataProduktivitas = H.toFixed(2)
    },
    initValues () {
      this.changeBidang = false
      this.changeDivisi = false
      this.changeKelompok = false
      this.changeSub = false
      this.dataBidang = 'pilih'
      this.dataDivisi = 'pilih'
      this.dataKelompok = 'pilih'
      this.dataSub = 'pilih'
      this.listDivisi = []
      this.listKelompok = []
      this.listSub = []

      this.dataAnalisa = 'pilih'
      this.changeAnalisa = false
      this.listAnalisa = []

      this.Thumbnail =  null
      this.dataUrutan = 'pilih'
      this.dataPenanganan = 'pilih'
      this.dataSubkontraktor = 0
      this.subshow = false
      this.changePenanganan = false,
      this.dataId = null
      this.dataPekerjaan = null
      this.dataHarga = 0
      this.dataKoefisienTenaga = 0
      this.dataSatuan = null
      this.dataUnit = null
      this.dataMulai = 0
      this.dataQuantity = 0
      this.dataTenaga = 1
      this.dataProduktivitas = 0
      this.dataTotal = 0
      this.dataHari = 0
      this.dataParent = null
    },
    cancelForm() {
      this.initValues()
      this.$emit('closeSidebar')
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.Thumbnail = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    PekerjaanCard
  },
  updated () {
    if (!this.currentPekerjaan) return
    if (this.currentPekerjaan.unread && this.isSidebarActive) this.$store.dispatch('pekerjaan/setUnread', { pekerjaanIds: [this.openPekerjaanId], unread: false })
  },
  created() {
    //alert(this.currentPekerjaan.ahsp.pekerjaan_divisi)
  },
}

</script>
<style lang="scss" scoped>
.vs-input-number {
  background: none;
}
.disabledbutton {
    pointer-events: none;
    opacity: 0.4;
}
</style>

